@if (model.loaded) {
  @if (hasAssignedProduct) {
    <rt-assigned-product-message-container />
  }

  <rt-box layout layout-vertical layout-align-items-center margin-bottom>
    <img margin-top-large class="illustration" src="{{ imageUrl }}" alt="" />

    <rt-heading variant="heading large-xx" margin-bottom-small-xx>
      {{ title }}
    </rt-heading>
    <p text-center margin-bottom text-medium [innerHTML]="message"></p>

    @if (showCta) {
      <rt-button (click)="goToOrder(); trackChoosePlan()" variant="primary" margin-bottom-small-x>
        <span>{{ cta }}</span>
        <rt-icon name="arrow-forward"></rt-icon>
      </rt-button>
    }
    @if (showAdminsAvatars) {
      <rt-admins-avatars
        [admins]="teamMembers"
        [editable]="false"
        [stacked]="true"
        [limit]="4"
      ></rt-admins-avatars>
    }
  </rt-box>

  @if (showFaq) {
    <rt-box layout layout-vertical margin-bottom>
      <rt-heading variant="heading large">{{
        'app.pricing.billing_locked_page.common_questions_header' | translate
      }}</rt-heading>
      <p margin-bottom-small-x>
        {{ 'app.pricing.billing_locked_page.common_questions_description' | translate }}
      </p>

      <div class="accordion">
        @for (item of commonQuestions; track trackByIndex($index); let isLast = $last) {
          <div
            class="accordion__item"
            [class.accordion__item--last]="isLast"
            [class.accordion__item--expanded]="expandedQuestions.has(item)"
          >
            <div (click)="toggle(item)" class="accordion__item-header">
              <rt-icon size="medium" name="chevron-right"></rt-icon>
              {{ item.questionKey }}
            </div>
            @if (expandedQuestions.has(item)) {
              <div [innerHTML]="item.answerKey" class="accordion__item-content"></div>
            }
          </div>
        }
      </div>
    </rt-box>
  }
  @if (invoices?.length) {
    <rt-billing-invoices
      [invoices]="invoices"
      [loading]="false"
      (downloadClick)="downloadInvoicePdf($event)"
      (loadMore)="onLoadMore()"
    ></rt-billing-invoices>
  }
}

@if (!model.loaded) {
  <rt-spinner></rt-spinner>
}
